<template lang="pug">
  .component-policy
    .inner-content(v-if="$is('listing')")
      .row
        .column.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
            CouponButtons(:item="item", @itemUpdated="$emit('itemUpdated')")

        .column
          .label CP{{item.id}}
          .field Code: {{item.code}}
        .column(v-if="item.common_cost !== null")
          .label {{item.common_cost.reason}}
          .field {{$priceWithcurrency($priceWithVat(item.common_cost.amount, item.common_cost.tax).toFixed(2))}}
        .column(v-else)
          .label Discount {{item.discount_rate}}%
        .column
          .label Valid from
          .field {{item.start}}
        .column
          .label Valid to
          .field {{item.end}}
        .column
          .label Max Uses
          .field {{item.max_uses === null ? 'unlimited' : item.max_uses}}
        .column
          .label Max Uses per driver
          .field {{item.max_uses_per_driver === null ? 'unlimited' : item.max_uses_per_driver}}
        .column
          .label Expiry Date
          .field {{item.expiry_date === null ? 'unlimited' : item.expiry_date}}
        .column
          .label Max Days
          .field {{item.max_days === null ? 'unlimited' : item.max_days}}
        .column
          .label Service
          .field {{item.service === null ? 'All' : item.service}}

</template>

<script>
  import CardN from '../structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import FederationButtons from '../structure/ui/actions/FederationButtons'
  import CouponButtons from '../structure/ui/actions/CouponButtons'

  export default {
    name: 'Coupon',
    components: {CouponButtons, FederationButtons, Dropdown, CardN},
    props: ['item', 'type']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Coupon.vue?4886ead0